import {
  isObject,
  extend,
  ssrDocument,
  ssr_window_esm_getDocument,
  ssrWindow,
  ssr_window_esm_getWindow,
  utils_classesToTokens,
  deleteProps,
  utils_nextTick,
  utils_now,
  utils_getComputedStyle,
  utils_getTranslate,
  utils_isObject,
  isNode,
  utils_extend,
  utils_setCSSProperty,
  animateCSSModeScroll,
  utils_getSlideTransformEl,
  utils_elementChildren,
  elementIsChildOfSlot,
  elementIsChildOf,
  showWarning,
  utils_createElement,
  utils_elementOffset,
  elementPrevAll,
  elementNextAll,
  elementStyle,
  elementIndex,
  utils_elementParents,
  utils_elementTransitionEnd,
  elementOuterSize,
  utils_makeElementsArray,
  utils_getRotateFix,
  support,
  calcSupport,
  getSupport,
  deviceCached,
  calcDevice,
  getDevice,
  browser,
  calcBrowser,
  getBrowser,
  Resize,
  Observer,
  eventsEmitter,
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  toggleSlideClasses$1,
  updateSlidesProgress,
  updateProgress,
  toggleSlideClasses,
  updateSlidesClasses,
  processLazyPreloader,
  unlazy,
  preload,
  getActiveIndexByTranslate,
  updateActiveIndex,
  updateClickedSlide,
  update,
  getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo,
  translate,
  setTransition,
  transitionEmit,
  transitionStart,
  transitionEnd,
  transition,
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide,
  slide,
  loopCreate,
  loopFix,
  loopDestroy,
  loop,
  setGrabCursor,
  unsetGrabCursor,
  grabCursor,
  closestElement,
  preventEdgeSwipe,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onResize,
  onClick,
  onScroll,
  onLoad,
  onDocumentTouchStart,
  events,
  attachEvents,
  detachEvents,
  events$1,
  isGridEnabled,
  setBreakpoint,
  getBreakpoint,
  breakpoints,
  prepareClasses,
  addClasses,
  removeClasses,
  classes,
  checkOverflow,
  checkOverflow$1,
  defaults,
  moduleExtendParams,
  prototypes,
  extendedDefaults,
  Swiper,
  Virtual,
  Keyboard,
  Mousewheel,
  create_element_if_not_defined_createElementIfNotDefined,
  Navigation,
  classes_to_selector_classesToSelector,
  Pagination,
  Scrollbar,
  Parallax,
  Zoom,
  Controller,
  A11y,
  History,
  HashNavigation,
  Autoplay,
  Thumb,
  freeMode,
  effect_init_effectInit,
  effect_target_effectTarget,
  effect_virtual_transition_end_effectVirtualTransitionEnd,
  EffectFade,
  EffectCube,
  create_shadow_createShadow,
  EffectFlip,
  EffectCoverflow,
  EffectCreative,
  EffectCards
} from "ccc-swiper";
/* CCC: swiper was inlined here by Flow's build; it now comes from the
   shared module above. See _upgrade-kit/README.md. */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/javascripts/webcomponents/image-with-text-slideshow.js



class ImageWithTextSlideshow extends HTMLElement {
  constructor() {
    super();
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
    this.handleInit = this.handleInit.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-image-with-text-slideshow'});
    this.init();

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  init() {
    const gridSliderWrapper = this.querySelector('[data-grid-slider-wrapper]');
    const scrollbarElement = gridSliderWrapper?.querySelector('.swiper-scrollbar');
    const nextEl = gridSliderWrapper?.querySelector('.swiper-button--next');
    const prevEl = gridSliderWrapper?.querySelector('.swiper-button--prev');

    // Initiate swiper
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      modules: [A11y, Navigation, Scrollbar],
      spaceBetween: 15,
      autoHeight: true,
      navigation: { prevEl, nextEl },
      scrollbar: { el: scrollbarElement, draggable: true },
      on: {
        init: this.handleInit
      },
      breakpoints: {
        768: { spaceBetween: 0 }
      },
    });
  }

  handleInit() {
    const gridSliderWrapper = this.querySelector('[data-grid-slider-wrapper]');
    if (gridSliderWrapper) gridSliderWrapper.classList.add('swiper-initialized');
  }

  handleBlockSelect(e) {
    const sectionId = e.detail.sectionId;
    if (this.sectionId != sectionId) return;

    const slideIndex = parseInt(e.target.dataset.swiperSlideIndex, 10);
    const isLoad = e.detail.load;
    const transitionDuration = isLoad ? 0 : 300; // Remove slide transition if a block setting is changed
    this.swiper.slideTo(slideIndex, transitionDuration, false);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }

    if (window.Shopify.designMode) {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }
}

if (!customElements.get('image-with-text-slideshow')) customElements.define('image-with-text-slideshow', ImageWithTextSlideshow);
/******/ })()
;